import { Directive, ElementRef, input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appHighlight]',
})
export class HighlightDirective {
  readonly appHighlight = input<any>(undefined);

  constructor(private el: ElementRef) {}

  ngOnChanges() {
    const appHighlight = this.appHighlight();
    if (!appHighlight || !appHighlight[0]) {
      this.el.nativeElement.innerHTML = appHighlight[1];
      return;
    }

    const re = new RegExp(appHighlight[0], 'gi');
    let value = appHighlight[1];
    if (typeof value !== 'string') {
      value = value + '';
    }
    this.el.nativeElement.innerHTML = value.replace(
      re,
      "<b style='background-color: #618c50;'>$&</b>"
    );
  }
}